module.exports = __webpack_public_path__ + "static/media/wallie01.0caaac79.jpg";